<template>
  <div id="requestAcct">
    <div class="container">
      <h1>Registration Success!</h1>
      <div class="row">
        <div class="col-12">
          <div class="alert alert-success alert-dismissible">
            <button type="button" class="close" data-dismiss="alert">
              &times;
            </button>
            <strong>Success</strong> You have successfully registered with JC
            Steele. You will receive an email confirming your registration once
            you have been approved.
          </div>
        </div>
      </div>
      <div id="RequestAcct" class="row">
        <div class="col-lg-12 pr-lg-0 mb-4 mb-lg-0">
          <h4>
            ***If you need to change any of your account information, please
            contact one of our reps.
          </h4>
        </div>
        <div class="col-lg-6 pr-lg-0 mb-4 mb-lg-0">
          <div class="ra-left">
            <div class="form-row">
              <label for="customerID">Customer ID</label>
              <input
                v-model="customerID"
                type="text"
                id="customerID"
                placeholder="Customer ID"
                readonly
              />
            </div>
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="firstName">First Name</label>
                <input
                  v-model="firstName"
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  readonly
                />
              </div>
              <div class="col-lg-6">
                <label for="lastName">Last Name</label>
                <input
                  v-model="lastName"
                  type="text"
                  id="lastName"
                  placeholder="Last Name"
                  readonly
                />
              </div>
            </div>
            <div class="form-row">
              <label for="email">Phone</label>
              <input
                v-model="phone"
                type="tel"
                id="phone"
                placeholder="(000) 000-0000"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 pl-lg-0">
          <div class="ra-right">
            <div class="form-row">
              <label for="companyName">Company Name</label>
              <input
                v-model="companyName"
                type="text"
                id="companyName"
                placeholder="Company Name"
                readonly
              />
            </div>
            <div class="form-row">
              <label for="address1">Ship To Address</label>
              <input
                v-model="address1"
                type="text"
                id="address1"
                placeholder="Address 1"
                readonly
              />
            </div>
            <div class="form-row">
              <label for="address2">Ship To Address Line 2</label>
              <input
                v-model="address2"
                type="text"
                id="address2"
                placeholder="Address 2"
                readonly
              />
            </div>
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="city">City</label>
                <input
                  v-model="city"
                  type="text"
                  id="city"
                  placeholder="City"
                  readonly
                />
              </div>
              <div class="col-lg-6">
                <label for="State">State</label>
                <input
                  type="text"
                  name="state"
                  v-model="state"
                  id="state"
                  readonly
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="postalCode">Postal Code</label>
                <input
                  v-model="postalCode"
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  readonly
                />
              </div>
              <div class="col-lg-6">
                <label for="Country">Country</label>
                <input
                  type="text"
                  name="country"
                  v-model="country"
                  id="country"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import $ from "jquery";
import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "Information",
  mounted() {
    this.registrationSuccess();
    this.getCountries();
    this.getStates();
    this.setCountry();
  },
  data() {
    return {
      user: "",
      companies: [],
      companyList: [],
      id: "",
      customerID: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      active: "",
      address1: "",
      address2: "",
      state: "",
      states: [],
      city: "",
      countries: [],
      country: "",
      postalCode: "",
      companyName: "",
      data: "",
    };
  },
  methods: {
    registrationSuccess() {
      //   console.log(this.$route.params.data);
      this.data = this.$route.params.data;
      this.address1 = this.data.bill_to_Address;
      // this.address2 = this.data.address2;
      this.city = this.data.bill_to_City;
      this.country = this.data.country;
      this.state = this.data.bill_to_State;
      this.postalCode = this.data.bill_to_ZipCode;
      this.companyName = this.data.bill_to_Name;
      this.customerID = this.data.customerID;
      this.firstName = this.data.first_Name;
      this.lastName = this.data.last_Name;
      // this.email = this.data.email;
      this.phone = this.data.phone;
    },
    getStates() {
      var states = [];
      apiService.getStatesByCountry("US").then((data) => {
        for (var i = 0; i < data.length; i++) {
          var state = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          states.push(state);
        }
        this.states = states;
      });
    },
    getCountries() {
      var countries = [];
      apiService.getCountries().then((data) => {
        for (var i = 0; i < data.length; i++) {
          var country = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          countries.push(country);
        }
        this.countries = countries;
      });

      this.country = "US";
    },
    setCountry() {
      setTimeout(function() {
        $("#countrySelect").dropdown("set selected", this.country);
        $(".ui.dropdown").dropdown({fullTextSearch:true});
      }, 1000);
    },
  },
};
</script>
